// Generated by openapi-codegen. Do not edit manually.

import * as z from 'zod';
import { v1PermissionSchema } from './v1/permissionSchema';
import { v1UnauthorizedErrorSchema } from './v1/unauthorizedErrorSchema';

export const listUserPermissionsPathParamsSchema = z.object({
  account_id: z.number().int().describe("Account ID"),
  user_id: z.number().int().describe("User ID"),
});

export const listUserPermissionsHeaderParamsSchema = z.object({
  Authorization: z.coerce.string().describe("OAuth 2.0 Bearer token"),
});

/**
 * @description Permissions retrieved successfully
 */
export const listUserPermissions200Schema = z.array(z.lazy(() => v1PermissionSchema));

/**
 * @description Unauthorized
 */
export const listUserPermissions401Schema = z.lazy(() => v1UnauthorizedErrorSchema);

export const listUserPermissionsQueryResponseSchema = z.lazy(() => listUserPermissions200Schema);
